(() => {
  if (customElements.get('ht-announcement')) return;
  class HairTempleAnnouncement extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-announcement-message]'));
      if (this.slides.length < 2) return;
      this.index = Math.max(0, this.slides.findIndex(slide => slide.dataset.active === 'true'));
      this.interval = Math.max(5000, Number(this.dataset.interval) || 6000);
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.focused = this.contains(document.activeElement);
      this.toggle = this.querySelector('[data-announcement-toggle]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('.ht-announcement-control').forEach(button => { button.hidden = false; });
      this.querySelector('[data-announcement-prev]').addEventListener('click', () => this.move(-1, true), options);
      this.querySelector('[data-announcement-next]').addEventListener('click', () => this.move(1, true), options);
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateControls();
        this.schedule();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => {
        this.focused = Boolean(event.relatedTarget && this.contains(event.relatedTarget));
        this.schedule();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.paused = true;
        this.updateControls();
        this.schedule();
      }, options);
      this.updateControls();
      this.schedule();
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.controller?.abort();
    }
    updateControls() {
      this.toggle.setAttribute('aria-label', this.paused ? 'Reanudar mensajes' : 'Pausar mensajes');
      this.toggle.querySelector('[data-pause-icon]').toggleAttribute('hidden', this.paused);
      this.toggle.querySelector('[data-play-icon]').toggleAttribute('hidden', !this.paused);
    }
    move(direction, manual = false) {
      if (manual) {
        this.paused = true;
        this.updateControls();
      }
      this.index = (this.index + direction + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.toggleAttribute('inert', !active);
        slide.setAttribute('aria-hidden', String(!active));
        if (active) slide.dataset.active = 'true';
        else delete slide.dataset.active;
      });
      if (manual) this.querySelector('[data-announcement-status]').textContent = this.slides[this.index].textContent.trim();
      this.schedule();
    }
    schedule() {
      window.clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || document.hidden) return;
      this.timer = window.setTimeout(() => this.move(1), this.interval);
    }
  }
  customElements.define('ht-announcement', HairTempleAnnouncement);
})();
